import React from 'react';
import { DynamicDataHandlerProps } from './rtfsModel';

export function UserRtfsValue({ data }: DynamicDataHandlerProps) {
	return (
		<div>
			<pre>{JSON.stringify(data.value, null, 2)}</pre>
		</div>
	);
}

export function UserRtfsKey({ data }: DynamicDataHandlerProps) {
	return (
		<div>
			<strong>{data.key}</strong>
		</div>
	);
}
